import { getCookie } from './cookies'

/**
 * El último carácter de la cookie `cookiesPolicy` indica si el usuario aceptó
 * la categoría de personalización (mismo contrato que en edo-entradas): '0'
 * significa que no, y el widget de valoración debe permanecer deshabilitado.
 * Sin widget de valoración aún en la UI (`rating_average` llega del backend
 * pero no se pinta) — este helper queda listo para conectarlo cuando exista.
 */
export function isRatingWidgetDisabled(): boolean {
  const cookiesPolicy = getCookie('cookiesPolicy')
  if (!cookiesPolicy) return false
  return cookiesPolicy.at(-1) === '0'
}
